import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/RAF/RAF_ELECTRONIC_HARDWARE_RGB_PRIMARY_LOGO_AW.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLineForPart, QuoteLineForServices } from './components/QuoteLine';
import { EstimatedQuantityOnHand } from './components/QuoteLine/EstimatedQuantityOnHand';
import { PartDescription } from './components/QuoteLine/PartDescription';
import { PartId } from './components/QuoteLine/PartId';
import { PartOptions } from './components/QuoteLine/PartOptions';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

const RAF_SITE_INFORMATION = [
  '95 Silvermine Road',
  'Seymour, CT 06483',
  'Phone (203) 888 - 2133',
  'Fax (203) 888 - 9860',
];

export function RAFQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo source={logo} extraStyles={[{ height: '25px' }]} />

        <SiteInformation
          name="RAF Electronic Hardware"
          items={RAF_SITE_INFORMATION}
        />

        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation />
      </QuoteDetails>

      <View
        style={[
          styles.row,
          { marginBottom: 10, paddingLeft: 10, paddingRight: 10 },
        ]}
      >
        <Text style={styles.bold}>
          Note: All quantities over 1,500 have a 12-week lead time.
        </Text>
      </View>

      {quoteLines.map((line) => {
        const { part, ...lineProps } = line;
        if (!part) {
          return <QuoteLineForServices {...line} showDescription />;
        }
        return (
          <QuoteLineForPart key={line.id} {...lineProps} part={part}>
            <PartId part={part} showCustomerPartId />

            <PartDescription description={part.description} />

            <PartOptions partOptions={line.partOptions} />

            <EstimatedQuantityOnHand qtyOnHand={line.estQtyOnHand} />
          </QuoteLineForPart>
        );
      })}

      <Specs />

      <EmployeeInformation />

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={[styles.bold, styles.textSmall]}>
            CONDITIONS OF SALE: 1. NO CONTRACT SHALL EXIST UNTIL SELLER RECEIVES
            ORDER FOR DELIVERY PLACED BY BUYER. 2. PRICES ARE SUBJECT TO CHANGE
            TO CONFORM TO PRICES PREVAILING AT TIME OF SHIPMENT. 3. PRICES ARE
            SUBJECT TO PRODUCTION RELEASES. WHERE REVISIONS RESULT IN HIGHER
            COSTS PRICES ARE SUBJECT TO CHANGE. 4. ALL PRICES ARE SUBJECT TO
            CHANGE TO CONFORM TO ALL STATE AND FEDERAL LAWS. 5. CHARGES MADE FOR
            TOOLS AND DIES DO NOT CONVEY THE RIGHT TO REMOVE THEM FROM OUR
            FACTORY. 6. IF ANY MATERIAL IS PROVED DEFECTIVE, SELLERS LIABILITY
            IS LIMITED TO REPLACEMENT ONLY AND SELLER WILL NOT PAY ANY CLAIM FOR
            LABOR ON OR FOR DAMAGE BY REASON OF ITS USE. 7. THE SELLER SHALL NOT
            BE LIABLE FOR INFRINGEMENT OF ANY PATENTS REQUIRED TO BE USED BY THE
            SPECIFICATIONS OF THE BUYER AND THE BUYER AGREES TO SAVE THE SELLER
            HARMLESS FOR ALL JUDGEMENTS, DECREES, COSTS AND OTHER LEGAL EXPENSES
            RESULTING FROM ANY SUITS AND AGREES TO DEFEND SELLER SHOULD SUCH A
            SUIT BE INSTITUTED. 8. GOODS SHALL BE INSPECTED WHEN RECEIVED AND
            THE SELLER IS NOT LIABLE FOR ANY DEFECTS UNLESS NOTIFIED WITHIN 30
            DAYS AFTER RECEIPT BY THE BUYER. 9. WE RESERVE THE RIGHT TO OVER AND
            UNDER SHIP BY ANY AMOUNT NOT TO EXCEED TEN PERCENT OF SPECIFIED
            QUANTITY. 10. ALL AGREEMENTS ARE CONTINGENT UPON STRIKES, ACCIDENTS
            AND OTHER DELAYS UNAVOIDABLE OR BEYOND OUR CONTROL.
          </Text>
          <Text>{'\n'}</Text>
          <Text>
            View Your Order Status & Tracking Online:{'\n'}
            For updates on your order status and tracking information, log in to
            your account on MWComponents.com using the same email address
            associated with your order. Navigate to My Account, then select
            Orders. If you do not already have an account, you can create one.
            Orders associated with the account email address will automatically
            populate.
          </Text>
          <Text>{'\n'}</Text>
          <Text>
            Quantity on hand is an estimate at the time of quote and will be
            validated when order is placed.
          </Text>
          <Text>{'\n'}</Text>
          <Text>
            Standard terms and conditions can be found on www.mwcomponents.com
            &lt;https://www.mwcomponents.com/mw-industries-terms-and-conditions&gt;
          </Text>
        </View>
      </View>
    </Page>
  );
}
